import React from "react";
import { useFullVisibleStyle } from "./Style";
import { useFullVisible } from "./useFullVisible";

interface IFullVisible {
  title: string;
  vendorCode: string;
  price: string;
  description: string;
  src: string;
  handleClickOut: () => void;
}

const FullVisible = ({
  handleClickOut,
  title,
  vendorCode,
  price,
  description,
  src,
}: IFullVisible) => {
  const { wrapperRef, isOpen, isTable } = useFullVisible(handleClickOut);

  return (
    <ExternalWrapperSC>
      <WrapperSC ref={wrapperRef}>
        <SvgContainer>
          <svg
            onClick={handleClickOut}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 11.4L12.9 14.3C13.0833 14.4833 13.3167 14.575 13.6 14.575C13.8833 14.575 14.1167 14.4833 14.3 14.3C14.4833 14.1167 14.575 13.8833 14.575 13.6C14.575 13.3167 14.4833 13.0833 14.3 12.9L11.4 10L14.3 7.1C14.4833 6.91667 14.575 6.68333 14.575 6.4C14.575 6.11667 14.4833 5.88333 14.3 5.7C14.1167 5.51667 13.8833 5.425 13.6 5.425C13.3167 5.425 13.0833 5.51667 12.9 5.7L10 8.6L7.1 5.7C6.91667 5.51667 6.68333 5.425 6.4 5.425C6.11667 5.425 5.88333 5.51667 5.7 5.7C5.51667 5.88333 5.425 6.11667 5.425 6.4C5.425 6.68333 5.51667 6.91667 5.7 7.1L8.6 10L5.7 12.9C5.51667 13.0833 5.425 13.3167 5.425 13.6C5.425 13.8833 5.51667 14.1167 5.7 14.3C5.88333 14.4833 6.11667 14.575 6.4 14.575C6.68333 14.575 6.91667 14.4833 7.1 14.3L10 11.4ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
              fill="#474748"
            />
          </svg>
        </SvgContainer>

        {!isTable && <ImgSC src={src} />}
        <RightWrapperSC>
          <TopWrapperSC>
            {!isTable && (
              <PriceSC>{price === "По запросу" ? price : `${price} ₽`}</PriceSC>
            )}
            {!isTable && <VendorCodeSC>{vendorCode}</VendorCodeSC>}
          </TopWrapperSC>
          <TitleSC>{title}</TitleSC>
          <DescriptionSC>{description}</DescriptionSC>
          {isTable && (
            <ContainerRow>
              <VendorCodeSC>{vendorCode}</VendorCodeSC>
              <PriceSC>{price === "По запросу" ? price : `${price} ₽`}</PriceSC>
            </ContainerRow>
          )}
        </RightWrapperSC>
      </WrapperSC>
    </ExternalWrapperSC>
  );
};

const {
  ImgSC,
  PriceSC,
  TitleSC,
  WrapperSC,
  VendorCodeSC,
  TopWrapperSC,
  DescriptionSC,
  RightWrapperSC,
  ExternalWrapperSC,
  ArticleSC,
  SvgContainer,
  ContainerRow,
} = useFullVisibleStyle();

export default React.memo(FullVisible);
